import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import RegistrationSuccess from "../pages/Registration/RegistrationSuccess";
import ForgotPassword from "../pages/Login/ForgotPassword";
import BasicTabs from "../pages/Home/Home";
import GenerateInvoice from "../pages/PatientManagement/InvoiceManagement/GenerateInvoice";
import Registration from "../pages/Registration/Registration";
import ResetPassword from "../pages/Login/RestPassword";
import ConsultationInvoice from "../pages/PatientManagement/InvoiceManagement/ConsultationInvoice";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/registration" element={<Registration />} />
    <Route path="/registration_success" element={<RegistrationSuccess />} />
    <Route path="/invoice" element={<GenerateInvoice />} />
    <Route path="/consultation-invoice" element={<ConsultationInvoice />} />
    <Route path="/forgotPassword" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />

    {/* ALL SECURED ROUTES */}
    <Route path="/*" element={<BasicTabs />} />

    <Route path="/home" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default AppRoutes;
